//Variables
let self = {};

self.ws = {};

self.canvasSize = {
    width: 672,
    height: 672
};

self.canvas = {};

self.direcciones = {
    up: 1,
    down: 2,
    right: 3,
    left: 4
};

self.seguroActivado = true;

self.engineStart = false;

self.moving = false;

self.varCloseForce = false;

// Cuántos tiles más allá del viewport visible el engine itera por
// frame. Necesario para que sprites grandes (árboles ~3 tiles altos,
// edificios) cuyo origen está fuera de pantalla todavía dibujen su
// parte visible. Valor original 9 era herencia del cliente VB6 con
// edificios más grandes; en este port nada pasa de 3-4 tiles, así
// que 3 cubre todo con margen.
//
// Performance: el loop iteraba 39×39 ≈ 1521 tiles (71% off-screen),
// 3 capas/frame = ~4563 drawImage/frame. Con 3 → 27×27 ≈ 729, 50%
// menos drawcalls off-screen. Recupera ~2ms de frame budget en
// zonas pesadas. Más detalle en el chat de la sesión #4.
//
// Si aparecen "pop-ins" al caminar rápido cerca de árboles/edificios
// grandes (su parte alta aparece 1 tile tarde al entrar a viewport),
// subir a 4-5 (sigue siendo 45-55% menos iteración que el original 9).
//
// HISTORIA: bajado a 3 en viewport refactor para ganar ~30% drawcalls.
// Después vimos pop-out de la fuente de Ullathorpe (5×5 tiles) al
// caminar rápido — su tile-borde caía 1 tile antes del buffer mid-
// animation. Subimos a 5 para cubrir fuentes + edificios grandes sin
// volver al baseline 9.
self.TileBufferSize = 5;

// Cuántos tiles iterar a cada lado del char local en los render loops.
// El viewport visible es 21×21 (canvasSize 672 / 32px), o sea ±10 desde
// el centro. El render itera ±(r-1)/±r asimétricamente (1 tile más en
// la dirección "long" que en la "short" — los dos windows de
// renderScreen están staggered por 1 tile para el blending de capas
// foreground/techos).
//
// LINKEADO A:
//   - canvasSize.width/height (arriba): 21 tiles × 32px = 672. Si
//     canvasSize crece a N tiles visibles, viewportRadius debería ser
//     ⌈N/2⌉ + 1 (al menos) para no recortar chars al borde.
//   - Pixel pitch del engine (`* 32` hardcoded en draws). No hace falta
//     tocar nada acá si solo cambia viewportRadius.
//
// Valor mínimo viable = ceil(visible-tiles / 2) + 1 buffer.
//   Para viewport actual 21: visible=11/lado, +1 buffer = 12 mínimo.
//
// HISTORIA — antes era 13 para cubrir el edge case "char salió del
// viewport hace 1 tile pero su sprite todavía está mid-animation". Pero
// con canvas=672 (21 tiles, center=índice 10), r=13 desplazaba el char
// 1 tile abajo-derecha del centro visible (porque screenminY = tileY-12
// → char en ScreenY=12 → pixel 352 vs canvas center 336).
//
// Volver a 12 recentra el char (screenminY = tileY-11 → ScreenY=11 →
// pixel 320, tile-center 336 = canvas center). El servidor sigue en 13
// (broadcast más conservador, no perdés visibility por la red), solo el
// cliente itera menos. Trade-off aceptado: edge animation puede saltarse
// 1 frame si el char justo cruza el borde, pero es invisible vs char
// descentrado.
//
// Performance: cada unidad extra agrega ~2r+1 tiles más de iteración
// por capa por frame. r=12 vs r=13 = -125 tiles/frame ≈ -8% drawcalls.
self.viewportRadius = 12;

self.XMinMapSize = 1;
self.XMaxMapSize = 100;
self.YMinMapSize = 1;
self.YMaxMapSize = 100;

self.OffsetXHead = 8;

self.actTechos = true;

self.mapNumber = 1;

// Ticket #238: bumped 230 → 203 para caminar +13% (~4.93 tiles/seg vs
// 4.35 original). Va de la mano con scrollPixelsPerFrame=10 (engine.js)
// y server alert threshold 5800ms (protocol.js position handler).
self.timeWalkMS = 203;

self.requestAnimationFrame =
    window.requestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.msRequestAnimationFrame;

self.dialogs = {};

self.spells = {};
self.items = {};

self.textMaxLength = 140;
self.manaLength = 124;
self.hpLength = 124;
self.xpLength = 223;
self.pingStart = 0;

self.intervalSpell = 750;
self.rangeInterval = self.intervalSpell;
self.intervalHit = 1000;
self.intervalItem = 200;

self.timeItemStart = 0;
self.timeSpellStart = 0;
self.timeHitStart = 0;
self.timeRangeStart = 0;
self.usersOnline = 0;

//Conections
self.debug = true;

self.descClient = {};

self.PROD_SERVER_ENDPOINT = "";
// Endpoint dinámico: si el browser entra por localhost/127.0.0.1 (dev local),
// va al WS local en :7666. Si entra por cualquier otro host (Cloudflare
// Tunnel, IP de LAN, dominio público), usa wss://ws.aoweb.net que pasa por
// el tunnel. Esto evita romper dev local cuando se mergea el cambio.
self.LOCAL_SERVER_ENDPOINT = (function () {
    if (typeof window === "undefined") return "ws://127.0.0.1:7666";
    var host = window.location.hostname;
    if (host === "127.0.0.1" || host === "localhost") {
        return "ws://127.0.0.1:7666";
    }
    var proto = window.location.protocol === "https:" ? "wss://" : "ws://";
    return proto + "ws.aoweb.net";
})();

// hechizoIdSpell: idSpell CANÓNICO del hechizo seleccionado para lanzar
// (no el slot/idPos). Antes era hechizoSelected=idPos pero el slot puede
// driftear (reordenamiento, learn/unlearn, desync cliente/server) y eso
// causaba que al castear Celeridad se lanzara Torpeza. Ahora la wire
// protocol manda idSpell y el server resuelve scaneando user.spells.
self.hechizoIdSpell = 0;
self.itemSelected = 0;

self.lastClickIdItem = 0;
self.clickUse = 0;

self.nameKeyCode = {
    flechaArriba: 0,
    flechaAbajo: 1,
    flechaIzquierda: 2,
    flechaDerecha: 3,
    usar: 4,
    atacar: 5,
    agarrar: 6,
    tirar: 7,
    equipar: 8,
    domar: 9,
    robar: 10,
    seguro: 11,
    meditar: 12,
    // Skill Ocultarse (#239) — tecla O default. Stealth de 5s con chance roll.
    ocultar: 13,
    // Ticket #287: refresh position. Tecla P default. Manda packet al
    // server que re-emite la pos canonical del char + setNewAreas →
    // resync del sprite cuando se bugea visualmente.
    refreshPosition: 14
};

self.keyCodeMap = {
    8: "Volver",
    9: "Tab",
    13: "Enter",
    16: "Shift",
    17: "Ctrl",
    18: "Alt",
    19: "PauseBreak",
    20: "Mayus",
    27: "Esc",
    32: "Barra",
    33: "Re Page",
    34: "Av Page",
    35: "End",
    36: "Home",
    37: "Flecha Izquierda",
    38: "Flecha Arriba",
    39: "Flecha Derecha",
    40: "Flecha Abajo",
    43: "+",
    44: "PrintScreen",
    45: "Insert",
    46: "Supr",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock"
};

self.keysTemp = [];

self.feedBackButtonOpen = false;

self.volume = 0.5;

self.opacity = 0;

self.selectedMacro;
self.itemSelectedMacro;
self.spellSelectedMacro;
self.keySelectedMacro;
self.fromCharSelectedMacro;
self.teclasMacros = [];
self.arMacros = {};

self.objType = {
    comida: 1,
    armas: 2,
    armaduras: 3,
    arboles: 4,
    dinero: 5,
    puerta: 6,
    objetoContenedor: 7,
    carteles: 8,
    llaves: 9,
    foros: 10,
    pociones: 11,
    libros: 12,
    bebidas: 13,
    lenia: 14,
    fogata: 15,
    escudos: 16,
    cascos: 17,
    anillos: 18,
    teleport: 19,
    muebles: 20,
    joyas: 21,
    yacimientos: 22,
    metales: 23,
    pergaminos: 24,
    aura: 25,
    instrumentosMusicales: 26,
    yunque: 27,
    fraguas: 28,
    gemas: 29,
    flores: 30,
    barcos: 31,
    flechas: 32,
    botellasVacias: 33,
    botellasLlenas: 34,
    manchas: 35,
    runaTeletransporte: 36
};

export default self;
